<h1>Brand Colors</h1>

<div class="color-container primary-brand-color">
  <div class="text__white">Here is some white text.</div>
  <div class="text__black">Here is some black text.</div>
  <div class="variations-container">
    <div class="third primary-brand-color">$primary-brand-color</div>
    <div class="third primary-brand-color-light">light-color($primary-brand-color)</div>
    <div class="third primary-brand-color-lighter">lighter-color($primary-brand-color)</div>
    <div class="clearfix"></div>
  </div>
</div>

<div class="color-container secondary-brand-color">
  <div class="text__white">Here is some white text.</div>
  <div class="text__black">Here is some black text.</div>
  <div class="variations-container">
    <div class="third secondary-brand-color">$secondary-brand-color</div>
    <div class="third secondary-brand-color-light">light-color($secondary-brand-color)</div>
    <div class="third secondary-brand-color-lighter">lighter-color($secondary-brand-color)</div>
    <div class="clearfix"></div>
  </div>
</div>

<div class="color-container accent-brand-yellow">
  <div class="text__white">Here is some white text.</div>
  <div class="text__black">Here is some black text.</div>
  <div class="variations-container">
    <div class="third accent-brand-yellow">$accent-brand-yellow</div>
    <div class="third accent-brand-yellow-light">light-color($accent-brand-yellow)</div>
    <div class="third accent-brand-yellow-lighter">lighter-color($accent-brand-yellow)</div>
    <div class="clearfix"></div>
  </div>
</div>

<div class="color-container accent-brand-grey">
  <div class="text__white">Here is some white text.</div>
  <div class="text__black">Here is some black text.</div>
  <div class="variations-container">
    <div class="third accent-brand-grey">$accent-brand-grey</div>
    <div class="third accent-brand-grey-light">light-color($accent-brand-grey)</div>
    <div class="third accent-brand-grey-lighter">lighter-color($accent-brand-grey)</div>
    <div class="clearfix"></div>
  </div>
</div>


<h2>Color Functions</h2>

<div>
  light-color($color, $useAlpha: false)
</div>
<div>
  lighter-color($color, $useAlpha: false)
</div>


<h4>$useAlpha: true/false</h4>

<div class="opacity-container" [ngStyle]="backgroundStyle">
  Background Color: <input [(ngModel)]="backgroundColor" />

  <div class="variations-container">
    <div class="third primary-brand-color">$primary-brand-color</div>
    <div class="third primary-brand-color-light">light-color($primary-brand-color)</div>
    <div class="third primary-brand-color-lighter">lighter-color($primary-brand-color)</div>
    <div class="clearfix"></div>
  </div>
  <div class="variations-container">
    <div class="third primary-brand-color">$primary-brand-color</div>
    <div class="third primary-brand-color-light__opaque">light-color($primary-brand-color, true)</div>
    <div class="third primary-brand-color-lighter__opaque">lighter-color($primary-brand-color, true)</div>
    <div class="clearfix"></div>
  </div>
  <div class="variations-container">
    <div class="third secondary-brand-color">$secondary-brand-color</div>
    <div class="third secondary-brand-color-light__opaque">light-color($secondary-brand-color, true)</div>
    <div class="third secondary-brand-color-lighter__opaque">lighter-color($secondary-brand-color, true)</div>
    <div class="clearfix"></div>
  </div>
  <div class="variations-container">
    <div class="third accent-brand-yellow">$accent-yellow</div>
    <div class="third accent-brand-yellow-light__opaque">light-color($accent-brand-yellow, true)</div>
    <div class="third accent-brand-yellow-lighter__opaque">lighter-color($accent-brand-yellow, true)</div>
    <div class="clearfix"></div>
  </div>
  <div class="variations-container">
    <div class="third accent-brand-grey">$accent-grey</div>
    <div class="third accent-brand-grey-light__opaque">light-color($accent-brand-grey, true)</div>
    <div class="third accent-brand-grey-lighter__opaque">lighter-color($accent-brand-grey, true)</div>
    <div class="clearfix"></div>
  </div>

</div>